import React from 'react'
import Block from '../block'
import { RichText } from '../richTextOptions'
import { Image } from '../BlockLibrary/Common/Image';

const ContentfulBlockPricingCards = card => {
    return (
        <div className="vethelp-pricing-col">
            <div className="vethelp-pricing-card">
                <div className="vethelp-card-header">
                    {card.cardHeader && <span>{card.cardHeader}</span>}
                </div>
                <div className="vethelp-card-body">
                    <div className="vethelp-card-text">
                        {card.cardText && <span>{card.cardText}</span>}
                    </div>
                    <div className="vethelp-card-price">
                        {card.pricingText && (
                            <RichText data={card.pricingText}></RichText>
                        )}
                    </div>
                </div>
                <div className="vethelp-card-footer">
                    {card.button && <Block block={card.button}></Block>}
                </div>
            </div>
        </div>
    )
}

export { ContentfulBlockPricingCards }
